<template>
  <BittsLayout class="c-data-sharing-page" :is-page="true">
    <template #content>
      <PageTitle
        title="Default Sharing"
        subtitle="These sharing settings apply to new partners."
        class="mb-40"
      >
        <template #action>
          <BittsButton
            text="Save"
            :disabled="!sharingSettingsTabRef?.hasChanges"
            @click="handleSave"
          />
        </template>
      </PageTitle>
      <SharingSettingsTab ref="sharingSettingsTabRef" class="m-0" />
    </template>
    <template #populations-modal>
      <router-view-wrapper />
    </template>
  </BittsLayout>
</template>

<script setup lang="ts">
import { BittsButton, BittsLayout } from '@crossbeam/bitts';

import { useHead } from '@unhead/vue';
import { ref } from 'vue';

import PageTitle from '@/components/PageTitle.vue';
import { SharingSettingsTab } from '@/components/partners/DataSharingSettings/SettingsModal/SharingSettingsTab';

useHead({
  title: 'Default Sharing - Crossbeam',
});

const sharingSettingsTabRef = ref<InstanceType<
  typeof SharingSettingsTab
> | null>(null);

async function handleSave() {
  await sharingSettingsTabRef.value?.triggerBulkUpdate();
}
</script>

<style scoped lang="pcss"></style>
